import {
  GENERATE_AI_RESPONSE,
  CLEAR_AI_SUGGESTION,
} from 'actions/AICopilotActions';

const initialState = {
  suggestion: '',
  isLoading: false,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case `${GENERATE_AI_RESPONSE}_PENDING`: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }

    case `${GENERATE_AI_RESPONSE}_FULFILLED`: {
      return {
        ...state,
        suggestion: payload,
        isLoading: false,
        error: null,
      };
    }

    case `${GENERATE_AI_RESPONSE}_REJECTED`: {
      return {
        ...state,
        isLoading: false,
        error: payload?.response?.data?.error?.message || payload?.message || 'Error generating AI response',
      };
    }

    case CLEAR_AI_SUGGESTION: {
      return {
        ...state,
        suggestion: '',
        error: null,
      };
    }

    default:
      return state;
  }
};
